import React, {Component} from 'react';
import $ from 'jquery';

const noBackgroundStyle = {
    background: 'none'
};

const messageStyle = {
   marginTop: '20px'
};

class ContactFormService {
    static postData(name, email, message) {
        return $.ajax({
            url: '/rest/contact',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                name: name,
                email: email,
                message: message
            })
        });
    }
}

export default class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            message: '',
            isSending: false,
            isSent: false,
            isFailed: false
        };
        this.service = ContactFormService;
    }

    inputChanged = e => {
        const state = this.state;
        state[e.target.id] = e.target.value;
        this.setState(state);
    };

    reset = () => {
        this.setState({name: '', email: '', message: ''});
    };

    sendData = () => {
        this.setState({isSending: true});
        this.service.postData(this.state.name, this.state.email, this.state.message)
            .done(() => {
                this.setState({isSent: true});
                this.reset();
            })
            .fail(e => {
                console.log('An error occurred sending message', e);
                this.setState({isFailed: true});
            })
            .always(() => this.setState({isSending: false}));
    };

    isValid = () => {
        return !!(this.state.name && this.state.email && this.state.message);
    };

    //noinspection JSMethodCanBeStatic
    render() {
        let button = null;
        if (this.state.isSent) {
            button = <div className="alert alert-success" style={messageStyle}>Message sent.</div>
        } else if (this.state.isFailed) {
            button = <div className="alert alert-danger" style={messageStyle}>Message failed to send.</div>
        } else if (!this.isValid()) {
            button = <button type="button" className="btn btn-default" style={noBackgroundStyle} disabled>Send</button>
        } else if (this.state.isSending) {
            button = <button type="button" className="btn btn-default" style={noBackgroundStyle} disabled>Sending...</button>
        } else {
            button = <button type="button" className="btn btn-default" onClick={this.sendData} style={noBackgroundStyle}>Send</button>
        }

        return (
            <form>
                <div className="form-group">
                    <label htmlFor="name">Name:</label>
                    <input type="text" className="form-control" id="name" placeholder="Name" value={this.state.name} onChange={this.inputChanged}/>
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input type="email" className="form-control" id="email" placeholder="Email" value={this.state.email} onChange={this.inputChanged}/>
                </div>
                <div className="form-group">
                    <label htmlFor="message">Message:</label>
                    <textarea className="form-control" id="message" rows="10" value={this.state.message} onChange={this.inputChanged}/>
                </div>
                {button}
            </form>);
    }
}


// WEBPACK FOOTER //
// ./src/contact-form.js